// PipelineStages.js
//
// Default Pipeline Stage options for Project (HH / K&B Lead Progression).

import { normalizeEnumOptions } from 'utilities/EnumOptions';

/** Stable option values in board/lane order. */
export const PROJECT_PIPELINE_STAGE_DEFAULTS = Object.freeze([
  { value: 'call', label: 'Call', color: '#e74c3c' },
  { value: 'fact_finding', label: 'Fact Finding', color: '#f1c40f' },
  { value: 'measure', label: 'Measure', color: '#e67e22' },
  { value: 'drawing', label: 'Drawing', color: '#5dade2' },
  { value: 'quoting', label: 'Quoting', color: '#9b59b6' },
  { value: 'present_layout', label: 'Present Layout / Selections get made', color: '#95a5a6' },
  { value: 'on_hold', label: 'Project on Hold', color: '#3f51b5' },
  { value: 'presented_waiting', label: 'Presented / Waiting', color: '#e91e63' },
  { value: 'won', label: 'Won', color: '#1abc9c' },
  { value: 'ordered', label: 'Ordered', color: '#7d8f3c' },
  { value: 'delivery', label: 'Delivery', color: '#b39ddb' },
  { value: 'install', label: 'Install', color: '#c2185b' },
]);

export const PROJECT_PIPELINE_STAGE_FIELD_NAME = 'pipelineStage';
export const PROJECT_PIPELINE_STAGE_DEFAULT_VALUE = 'call';

/**
 * Default Appear-as rows for PROJECT: Leads vs Projects.
 *
 * @returns {object[]}
 */
export function buildProjectAppearAsRows() {
  return [
    {
      key: 'lead',
      label: 'Lead',
      labelPlural: 'Leads',
      iconKey: 'handshake',
      filters: [{
        field: PROJECT_PIPELINE_STAGE_FIELD_NAME,
        operator: 'is',
        value: PROJECT_PIPELINE_STAGE_DEFAULT_VALUE,
        unit: null,
        type: 'enum',
        joinToNext: 'and',
      }],
      initialFields: { [PROJECT_PIPELINE_STAGE_FIELD_NAME]: PROJECT_PIPELINE_STAGE_DEFAULT_VALUE },
      defaultSurface: 'records',
      showInMenu: true,
      showInAddMenu: true,
    },
    {
      key: 'project',
      label: 'Project',
      labelPlural: 'Projects',
      iconKey: 'handyman',
      filters: [{
        field: PROJECT_PIPELINE_STAGE_FIELD_NAME,
        operator: 'is',
        value: 'won',
        unit: null,
        type: 'enum',
        joinToNext: 'and',
      }],
      initialFields: { [PROJECT_PIPELINE_STAGE_FIELD_NAME]: 'won' },
      defaultSurface: 'records',
      showInMenu: true,
      showInAddMenu: true,
    },
  ];
}

/**
 * Builds a canonical Project Pipeline Stage field definition.
 *
 * @returns {object}
 */
export function buildProjectPipelineStageField() {
  const options = normalizeEnumOptions(
    PROJECT_PIPELINE_STAGE_DEFAULTS.map((entry, index) => ({
      value: entry.value,
      label: entry.label,
      color: entry.color,
      sortOrder: index,
    })),
  );

  return {
    name: PROJECT_PIPELINE_STAGE_FIELD_NAME,
    slug: 'pipeline_stage',
    label: 'Pipeline Stage',
    type: 'pipeline',
    source: 'PROJECT',
    displayAsPill: true,
    enumOptionsSort: 'manual',
    default: PROJECT_PIPELINE_STAGE_DEFAULT_VALUE,
    options,
  };
}
